import React from "react";
import classNames from "classnames";
import styles from "./CatalogListItemOutput.module.scss";
import Checkbox from "../../../../common/components/Checkbox";
import FormatPrice from "../../../../common/components/FormatPrice";
import Icon from "../../../../common/components/Icon";
import Button from "react-bootstrap/Button";
import {CatalogListItemProps} from "./types";
import {useTranslation} from "react-i18next";
import {getDateTimeTuple} from "../../../../common/utils/dateTimeHelpers";

/**
 * Вывод одной позиции списка продуктов/атрибутов каталога
 */
const CatalogListItemOutput: React.VFC<CatalogListItemProps> = ({
  compositeId,
  name,
  description,
  imagePreviewUrl,
  showImage,
  portionSize,
  price,
  disabledUntil,
  enabled,
  enableHandler,
  editHandler,
  selectHandler,
  checkboxStatus,
  level,
  isReadOnly = false,
}) => {

  const {t} = useTranslation('translation', {keyPrefix: 'features.catalog'});

  const formattedClosedUntil = disabledUntil
    ? getDateTimeTuple(disabledUntil, {
        todayLocale: "сегодня",
        previousDayLocale: "вчера",
        nextDayLocale: "завтра",
      })?.join(', ')
    : null;

  const isThirdLevel = level === 'third';

  return <div className={classNames(
    styles["list-item"],
    styles[`list-item--${level}-level`],
  )}>
    <div className={classNames("d-flex", isThirdLevel ? styles["list-item-content"] : "justify-content-between align-items-center")}>
      <div className={classNames("d-flex flex-nowrap", isThirdLevel && description && styles["list-item-left--has-desc"])}>
          <div className={styles["list-item-controls"]}>
            {!isReadOnly && <div className={styles["list-item-select"]}>
              <Checkbox
                  id={`select-dish-${compositeId}`}
                  checked={checkboxStatus === "checked"}
                  onChange={selectHandler}
                  state={checkboxStatus === "partial" ? ["control--partial"] : undefined}
              />
            </div>}
            {isThirdLevel && showImage && <div className={classNames(styles["list-item-thumbnail"], !enabled && styles["list-item-thumbnail--disabled"])}>
              {imagePreviewUrl
                ? <img src={imagePreviewUrl} alt={name} />
                : <div className={styles["list-item-thumbnail-placeholder"]}>
                    <img src="/nophoto.svg" alt="" />
                  </div>}
            </div>}
          </div>
          <div>
            <div className="d-flex flex-wrap align-items-baseline">
              <div className={classNames(styles["list-item-title"], !enabled && styles["list-item-title--disabled"])}>{name}</div>
              {portionSize && <div className={classNames(styles["list-item-desc"])}>{portionSize}</div>}
            </div>
            {isThirdLevel && description && <div className={classNames(styles["list-item-description"], !enabled && styles["list-item-description--disabled"])}>{description}</div>}
          </div>
      </div>
      {!isReadOnly && !enabled && typeof price === "number" && enableHandler && <Button
          className={styles["list-item-enable-mobile"]}
          variant="outline-success"
          size="sm"
          onClick={() => compositeId && enableHandler(compositeId)}>
        {t(`actionEnable`)}
      </Button>}
      {typeof price === "number" && <div className={classNames(styles["list-item-price-wrapper"])}>
          {portionSize && <div className={styles["list-item-portion-mobile"]}>{portionSize}</div>}
          <div className={classNames(styles["list-item-price"], !enabled && styles["list-item-price--disabled"], "text-end me-2")}>
              <FormatPrice value={price}/> ₸
          </div>
          {!isReadOnly && editHandler && <div className={styles["list-item-action"]} onClick={() => {
            if (compositeId) {
              editHandler({compositeId, price, name, description, portionSize: portionSize});
            }
          }}>
            <Icon icon="edit"/>
          </div>}
      </div>}
    </div>
    {!enabled &&
      <div className={classNames(styles["list-item-status-row"])}>
          {!isReadOnly && enableHandler && <Button
              className={styles["list-item-enable-desktop"]}
              variant="outline-success"
              onClick={() => compositeId && enableHandler(compositeId)}>
            {t(`actionEnable`)}
          </Button>}
          <div className={styles["list-item-status-row-desc"]}>
            {formattedClosedUntil
              ? t(`disabledUntil`, {datetime: formattedClosedUntil})
              : t(`disabledIndefinite`)}
          </div>
      </div>}
  </div>;
}

export default CatalogListItemOutput;
